<div class="bg-[#491176] min-h-screen">
	<portals-navbar></portals-navbar>
	<div class="container" style="padding-top: 100px;">
        <h1 class="text-[#fbd354] block font-roboto font-medium leading-[72px] m-0 text-center max-w-[960px] title" style="width: calc(100vw - 80px);">
            Empowering Voices, Shaping Futures: Transforming Feedback into Actionable Insights with AI</h1>
		
            <img src="/assets/images/jotto-company-banner.png" class="banner flex items-center rounded-[12px] cursor-pointer justify-center overflow-hidden relative object-cover object-top mt-[80px]" />
        
        <p class="box-border text-white block font-roboto font-normal leading-[28px] m-0 w-full max-w-[960px] mt-5 content">
			Jotto is a platform that uses artificial intelligence to transform feedback into actionable insights for local government and large organizations. It encourages authentic expression and participation, breaking down barriers with a registration-free interface accessible via QR code or link. Jotto offers a powerful tool for engaging audiences, informing strategic decisions, and fostering a more inclusive community, driving meaningful change and achieving shared goals.
		</p>
	</div>
	<div style="margin-top: 120px">
		<h2 class="box-border text-[#fbd354] block font-roboto font-bold mb-5 text-center" style="font-size: 60px; line-height: 60px; ">TEAM JOTTO</h2>
	</div>
    <div class="flex flex-wrap justify-center" style="max-width: 1200px; margin: 0 auto;">
        <div class="max-w-sm bg-[#491176] shadow-lg rounded-lg overflow-hidden my-4 mx-2">
            <img class="w-full h-56 object-cover object-center" src="/assets/images/jason-profile.png" alt="avatar" style="width: 400px; height: 310px; object-fit: cover;" />
            <div class="py-4 px-6">
                <div class="flex justify-between items-center">
                    <h1 class="text-2xl font-semibold text-white m-0">Jason Van Anden</h1>
                    <div class="social-link cursor-pointer ml-3" onclick="window.open('https://www.linkedin.com/in/vananden/')" style="color: #fbd364; font-size: 30px">
                        <i class="fab fa-linkedin"></i>
                    </div>
                </div>
                <h2 class="text-xl font-semibold text-white">Founder & CEO</h2>
                <p class="py-2 text-lg text-white">Jason Van Anden is an accomplished inventor, artist, and engineer. He founded Quadrant 2 in 1996, where he has created an array of technologies for companies large and small ranging from industrial robotics to beloved consumer facing apps.</p>
                <div class="flex items-center justify-center py-2">
                    <img class="h-20 w-20 cursor-pointer" src="/assets/images/jason-qr-code.png" loading="lazy" alt="" />
                    <div class="text-center ml-4">
                        <h3 class="text-[#fbd364] cursor-pointer font-roboto text-lg font-normal">
                            CONNECT
                            <br />
                            WITH JASON!
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="max-w-sm bg-[#491176] shadow-lg rounded-lg overflow-hidden my-4 mx-2">
            <img class="w-full h-56 object-cover object-center" src="/assets/images/simone-profile.jpg" alt="avatar" style="width: 400px; height: 310px; object-fit: cover;" />
            <div class="py-4 px-6">
                <div class="flex justify-between items-center">
                    <h1 class="text-2xl font-semibold text-white m-0">Simone Tarantino</h1>
                    <div class="social-link cursor-pointer ml-3" onclick="window.open('https://www.linkedin.com/in/simonetarantino/')" style="color: #fbd364; font-size: 30px">
                        <i class="fab fa-linkedin"></i>
                    </div>
                </div>
                <h2 class="text-xl font-semibold text-white">Chief Operating Officer</h2>
                <p class="py-2 text-lg text-white">With over 25 years in tech and business, and an AI background from MIT, Simone has founded companies across media, social impact, and tech verticals, serving both B2B and B2C markets.He is a sought-after author, speaker, and advisor in startup.</p>
                <div class="flex items-center justify-center py-2">
                    <img class="h-20 w-20 cursor-pointer" src="/assets/images/simone-qr-code.png" loading="lazy" alt="" />
                    <div class="text-center ml-4">
                        <h3 class="text-[#fbd364] cursor-pointer font-roboto text-lg font-normal">
                            CONNECT
                            <br />
                            WITH SIMONE
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="max-w-sm bg-[#491176] shadow-lg rounded-lg overflow-hidden my-4 mx-2">
            <img class="w-full h-56 object-cover object-center" src="/assets/images/raf-profile.png" alt="avatar" style="width: 400px; height: 310px; object-fit: cover;" />
            <div class="py-4 px-6">
                <div class="flex justify-between items-center">
                    <h1 class="text-2xl font-semibold text-white m-0">Rafid Karim</h1>
                    <div class="social-link cursor-pointer ml-3" onclick="window.open('https://www.linkedin.com/in/raf-karim/')" style="color: #fbd364; font-size: 30px">
                        <i class="fab fa-linkedin"></i>
                    </div>
                </div>
                <h2 class="text-xl font-semibold text-white">Lead Engineer</h2>
                <p class="py-2 text-lg text-white">Rafid, the lead engineer, drives the tech evolution. From crafting app features, web apps, APIs, and databases to overseeing deployments and guiding our engineering team, Rafid's journey from intern to lead engineer symbolizes his dedication to technology and innovation.</p>
                <div class="flex items-center justify-center py-2">
                    <img class="h-20 w-20 cursor-pointer" src="/assets/images/rafid-qr-code.png" loading="lazy" alt="" />
                    <div class="text-center ml-4">
                        <h3 class="text-[#fbd364] cursor-pointer font-roboto text-lg font-normal">
                            CONNECT
                            <br />
                            WITH RAFID!
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="max-w-sm bg-[#491176] shadow-lg rounded-lg overflow-hidden my-4 mx-2">
            <img class="w-full h-56 object-cover object-center" src="/assets/images/chad-profile.png" alt="avatar" style="width: 400px; height: 310px; object-fit: cover;" />
            <div class="py-4 px-6">
                <div class="flex justify-between items-center">
                    <h1 class="text-2xl font-semibold text-white m-0">Chad Mathlin</h1>
                    <div class="social-link cursor-pointer ml-3" onclick="window.open('https://www.linkedin.com/in/chad-mathlin-b19836236/')" style="color: #fbd364; font-size: 30px">
                        <i class="fab fa-linkedin"></i>
                    </div>
                </div>
                <h2 class="text-xl font-semibold text-white">Customer Success Manager</h2>
                <p class="py-2 text-lg text-white">As part of my accomplishments, I designed a demo web feed version of "Jotto,"  presenting card components for individual channels through coding. Moreover, I crafted a "Jotto Demo" follow-up page, intended for channel subscription on the web-based platform.</p>
                <div class="flex items-center justify-center py-2">
                    <img class="h-20 w-20 cursor-pointer" src="/assets/images/chad-qr-code.png" loading="lazy" alt="" />
                    <div class="text-center ml-4">
                        <h3 class="text-[#fbd364] cursor-pointer font-roboto text-lg font-normal">
                            CONNECT
                            <br />
                            WITH CHAD!
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="max-w-sm bg-[#491176] shadow-lg rounded-lg overflow-hidden my-4 mx-2">
            <img class="w-full h-56 object-cover object-center" src="/assets/images/sgr-profile.png" alt="avatar" style="width: 400px; height: 310px; object-fit: cover;" />
            <div class="py-4 px-6">
                <div class="flex justify-between items-center">
                    <h1 class="text-2xl font-semibold text-white m-0">Sagar Shrestha</h1>
                    <div class="social-link cursor-pointer ml-3" onclick="window.open('https://www.linkedin.com/in/sagr2848/')" style="color: #fbd364; font-size: 30px">
                        <i class="fab fa-linkedin"></i>
                    </div>
                </div>
                <h2 class="text-xl font-semibold text-white">Full stack software engineer</h2>
                <p class="py-2 text-lg text-white">With expertise in end-to-end software development, data optimization, and a strong foundation in programming, databases, and frameworks, I embrace new opportunities with enthusiasm, fostering holistic problem-solving through mentoring and volunteering for meaningful outcomes.</p>
                <div class="flex items-center justify-center py-2">
                    <img class="h-20 w-20 cursor-pointer" src="/assets/images/sagar-qr-code.png" loading="lazy" alt="" />
                    <div class="text-center ml-4">
                        <h3 class="text-[#fbd364] cursor-pointer font-roboto text-lg font-normal">
                            CONNECT
                            <br />
                            WITH SAGAR!
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    

	<portals-footer></portals-footer>
</div>
